<template>
    <div class="error-container w-100 h-100 d-flex bg-white align-items-center justify-content-center">
        <div class="wrapper col-xs-12 col-lg-10 d-flex flex-column-reverse flex-xl-row align-items-start align-items-xl-center">
            <div class="d-flex flex-column text col-xs-12 col-xl-6 p-2 p-md-5 align-items-center align-items-xl-start">
                <div class="yarn mb-5">
                    <img :src="ball"/>
                </div>
                <span class="text-uppercase title d-flex flex-column mb-5 text-center text-xl-left">
                    <span>У&nbsp;вас недостаточно прав&nbsp;для</span>
                    <span>просмотра данной страницы</span>
                </span>
                <span>
                    <b-button variant="primary" @click="goToIndex" class="index-button">
                        <span class="text-uppercase h2">
                            Вернуться на главную
                        </span>
                    </b-button>
                </span>
            </div>
            <div class="cat col-xs-12 col-xl-6 p-5">
                <img :src="cat" />
            </div>
        </div>
    </div>

</template>

<script>
    import cat from '../../assets/img/pets_403.svg'
    import ball from '../../assets/img/pets_403_1.svg'


    export default {
        name: "Error404",
        data() {
            return {
                cat,
                ball
            }
        },
        methods: {
            goToIndex() {
                this.$router.replace('/');
            }
        }
    }

</script>

<style scoped lang="scss">

    .title {
        font-weight: 600;
        font-size: 36px;
    }

    .index-button {
        padding: 18px 36px;
    }

    .cat {
        & img {
            width: 100%;
        }
    }

    .yarn {
        & img {
            width: 100%;
        }
    }

    .error-container {
        min-height: 100vh;
    }

    @media only screen and (max-device-height: 480px)
                       and (max-device-width: 1024px)
                       and (orientation: landscape) {
        .wrapper {
            align-items: center !important;
        }
        .text {
            padding: 10px !important;
            width: auto;
            align-items: center !important;
            text-align: center;
        }
        .cat {
            height: 300px;
            width: auto;
            padding: 10px !important;
            margin-top: 30px;
            & img {
              height: 100%;
              width: unset;
            }
        }
    }

</style>